export var headers = {
	"Project-Id-Version": "Open-Xchange 7",
	"Report-Msgid-Bugs-To": "",
	"POT-Creation-Date": "",
	"PO-Revision-Date": "2023-03-22 14:21+0100",
	"Last-Translator": "NAME <EMAIL>",
	Language: "de_DE",
	"Language-Team": "OX <i18n@open-xchange.com>",
	"Content-Type": "text/plain; charset=UTF-8",
	"Content-Transfer-Encoding": "8bit",
	"Plural-Forms": "nplurals=2; plural=(n != 1);",
	"MIME-Version": "1.0",
	"X-Generator": "Poedit 3.2.2"
};
export default {
	headers: headers,
	"\u0000Ask me later\u0001": [
	"Später fragen"
],
	"\u0000Before you can continue, please select your timezone.\u0001": [
	"Bevor du fortfährst, wähle bitte deine Zeitzone."
],
	"\u0000Close\u0001": [
	"Schließen"
],
	"\u0000Learn about shared calendar\u0001": [
	"Informationen über den freigegebenen Kalender"
],
	"\u0000Timezone\u0001": [
	"Zeitzone"
],
	"\u0000Upgrade Storage\u0001": [
	"Upgrade für Speicher"
],
	"\u0000Welcome to %s\u0001": [
	"Willkommen bei professioneller E-Mail"
]
};
